
import TabBar, {TabBarRef} from './Tabs';

export default TabBar;
export type {TabBarRef};